import * as React from 'react';
import './newCardForm.module.scss';
import { observer } from 'mobx-react';
import { NewCardFormState } from './states/CardPaymentState';
type InputProps = {
    name: string;
    value: string;
    error?: string;
    placeholder: string;
    onChange: (nextValue: string) => any;
};

const FormInput = ({ name, value, error, placeholder, onChange }: InputProps) => {
    return (
        <div styleName="form-input-wrapper">
            <input
                type="text"
                styleName="form-input"
                name={name}
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
            />
            {error && <div styleName="error">{error}</div>}
        </div>
    );
};

type Props = {
    state: NewCardFormState;
};

@observer
export class NewCardForm extends React.Component<Props> {
    render() {
        const { state } = this.props;
        return (
            <div styleName="new-card-form">
                <div styleName="form-header">クレジットカード</div>
                <div styleName="number-form">
                    <FormInput
                        name="number"
                        value={state.getValue('number')}
                        error={state.getError('number')}
                        placeholder="0000-0000-0000-0000"
                        onChange={(v) => state.setValue('number', v)}
                    />
                </div>
                <div styleName="exp-cvc">
                    <FormInput
                        name="exp"
                        value={state.getValue('exp')}
                        error={state.getError('exp')}
                        placeholder="MM/YY"
                        onChange={(v) => state.setValue('exp', v)}
                    />
                    <FormInput
                        name="cvc"
                        value={state.getValue('cvc')}
                        error={state.getError('cvc')}
                        placeholder="CVC"
                        onChange={(v) => state.setValue('cvc', v)}
                    />
                </div>
            </div>
        );
    }
}
